module.exports = __webpack_public_path__ + "img/fig_rosalee_it.fa9f30d2.png";